import React from "react";
import toysBg from "../assets/toys-bg.png";
import Basic from "../assets/basic.png";
import Advanced from "../assets/advance.png";
import Pro from "../assets/pro.png";
import Ultra from "../assets/ultra.png";
import { useSubscription } from "../../context/SubscriptionContext";
import { useNavigate } from "react-router-dom";

const PricingPlans = () => {
   const navigate = useNavigate();
   
  const { plans, loading, selectedPlan, setSelectedPlan, addToCart } =
    useSubscription();

  const handleChoosePlan = (plan) => {
    addToCart(plan); // 🛒 Add to cart
    // setSelectedPlan(plan); // 🪟 Show modal
    navigate("/cartSection"); // 🛒 Go to cart page
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen text-lg text-gray-700">
        Loading plans...
      </div>
    );
  }

  return (
    <div
      className="min-h-screen bg-cover bg-center flex items-center justify-end px-6 py-12"
      style={{ backgroundImage: `url("https://cdn.acsdev.in/Rentastic/toysb.png")` }}
    >
      {/* Plans Grid */}
      <div className="max-w-6xl w-full grid grid-cols-1 sm:grid-cols-2 gap-6">
        {plans.map((plan, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-lg p-6 flex flex-col justify-between relative"
          >
            {/* Price over Image */}
            <div className="absolute top-2 right-2 w-20 h-20">
              <img
                src={
                  plan.name.toLowerCase().includes("basic")
                    ? Basic
                    : plan.name.toLowerCase().includes("advanced")
                    ? Advanced
                    : plan.name.toLowerCase().includes("pro")
                    ? Pro
                    : Ultra
                }
                alt={`${plan.name} badge`}
                className="w-full h-full object-contain -mt-4"
              />
              <div className="absolute inset-0 flex items-center justify-center -mt-8 text-center">
                <span className="text-white text-sm font-semibold leading-tight">
                  $ {plan.price}
                  <br />
                  <span className="text-xs font-light">{plan.per}</span>
                </span>
              </div>
            </div>

            {/* Plan Name */}
            <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">
              {plan.name}
            </h3>

            {/* Features */}
            <ul className="space-y-2 mb-4 text-gray-600 text-sm">
              {plan.features.map((feature, idx) => (
                <li key={idx}>✔ {feature}</li>
              ))}
            </ul>

            {/* Button */}
            <button
              onClick={() => handleChoosePlan(plan)}
              className="bg-white text-green-800 border-2 border-green-800 py-2 rounded-2xl w-full hover:bg-green-800 hover:text-white transition"
            >
              Choose Plan
            </button>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedPlan && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-md flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl p-6 w-80 relative">
            {/* Close Button */}
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-black"
              onClick={() => setSelectedPlan(null)}
            >
              ✕
            </button>

            {/* Plan Info */}
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold">{selectedPlan.name}</h3>
              <div className="relative w-20 h-20">
                <img
                  src={Ultra}
                  alt={`${selectedPlan.name} badge`}
                  className="w-full h-full object-contain -mt-8"
                />
                <div className="absolute inset-0 flex items-center justify-center -mt-12 text-center">
                  <span className="text-white text-sm font-semibold leading-tight">
                    $ {selectedPlan.price}
                    <br />
                    <span className="text-xs font-light">
                      {selectedPlan.per}
                    </span>
                  </span>
                </div>
              </div>
            </div>

            {/* Features */}
            <ul className="space-y-2 text-gray-600 text-sm">
              {selectedPlan.features.map((feature, idx) => (
                <li key={idx}>✔ {feature}</li>
              ))}
            </ul>

            {/* Store Buttons */}
            <div className="mt-6 text-center text-sm text-gray-700">
              Download it now from the Google Play Store or the Apple App Store
              <div className="flex justify-center gap-4 mt-2">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Google Play"
                  className="h-10"
                />
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="App Store"
                  className="h-10"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingPlans;
